








































import Vue from 'vue'
import mixin from '@/mixins/msg-text-form-mixin'
import { Mentionable } from 'vue-mention'
import 'floating-vue/dist/style.css'
import { debounce } from 'debounce'
export default Vue.extend({
    components: { Mentionable },
    mixins: [mixin],
    props: {
        rows: {
            type: Number,
            default: 3
        },
        text: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            currentMention: null
        }
    },
    computed: {
        items() {
            //  Grab our users
            const users = this.$store.getters.users

            //  If we haven't yet gotten our users, return an empty array
            if (!users || !users.length) return []

            //  Container for our items
            const items = []

            //  Start our items with "Team"
            items.push({
                id: 'Team',
                value: 'Team',
                name: 'Team',
                logo: 'Team'
            })

            //  Iterate through our items
            for (let i = 0; i < users.length; i++) {
                //  Add this to our container
                items.push({
                    id: users[i].id,
                    value: this.$options.filters.userFullNameOrEmail(users[i]),
                    name: this.$options.filters.userFullNameOrEmail(users[i]),
                    logo: users[i].logo_route ? users[i].id : null,
                    placeholder: this.$options.filters.userInitials(users[i])
                })
            }

            //  Return our items
            return items
        },
        userLogos(): object {
            //  Grab all of our users
            const users = this.$store.getters.users

            //  Container for our users
            const mentionable = {}

            //  By default, include "Team"
            mentionable['Team'] = this.$images.brandMark

            //  Iterate through each user
            for (let i = 0; i < users.length; i++) {
                //  Grab the logo route for this user
                let logo = users[i].logo_route

                //  If they have no logo route, go to the next
                if (!logo) continue

                //  For each user, set logo route remote link
                mentionable[users[i].id] = logo.remote_link
            }

            //  Return the mentionable users
            return mentionable
        }
    },
    methods: {
        appendText(txt: string): void {
            //  Grab our node
            const node = document.getElementById('message-text-box')

            //  Check if our node currently has any HTML in it
            const empty = !node.innerHTML

            //  If it is empty, don't include a space
            const formatted = empty ? `${txt}` : ` ${txt}`

            //  Update the innerHTML by appending our text to it
            node.innerHTML = node.innerHTML + formatted

            //  Tell our parent
            this.$emit('onInput', txt)

            //  Also focus our input
            this.placeCursor(node)
        },
        checkForMentions(elem: HTMLInputElement): void {
            //  Grab the text from this input event
            const val = elem.innerText

            //  Grab the current mention value
            const mention = this.currentMention.value

            //  Check if we have any mentions
            const contains = val.includes(mention)

            //  If it doesn't contain, we are done
            if (!contains) return

            //  Else, replace this with our mention styling
            this.replaceMention(elem)

            //  Place the cursor at the end
            this.placeCursor(elem)
        },
        insertMention(): void {
            //  Update our text and autofocus
            this.appendText('@')

            //  Get the mentions menu to pop
            this.$refs.mentionBox.checkKey()
        },
        onApply(event): void {
            //  Replace this with a highlighted version
            this.currentMention = {
                value: `@${event.value}`,
                id: event.id
            }
        },
        onInputBuffer: debounce(function (event: InputEvent): void {
            //  Grab our element
            const elem = event.target as HTMLInputElement

            //  Grab the data from this input event
            const val = elem.innerText

            //  This is an inputEvent if it contains the "inputType" property (onApply never includes this)
            const inputEvent = event.inputType

            //  Check if we have mentions IF this is NOT an input type
            if (!inputEvent) this.checkForMentions(elem)

            //  Call our onInput
            this.onInput(val)
        }),
        onPaste(e): void {
            //  Container for our text
            let text = ''

            //  Our data is different depending on browser, so check for either
            if (e.clipboardData || e.originalEvent.clipboardData) {
                //  Grab the clipboard data from our event
                text = (e.originalEvent || e).clipboardData.getData('text/plain')
            }
            //  @ts-ignore Else, if our event doesn't have clipboard data, check the window
            else if (window.clipboardData) {
                //  @ts-ignore Grab the clipboard data from the window
                text = window.clipboardData.getData('Text')
            }

            //  Insert our text (different browsers support different actions)
            if (document.queryCommandSupported('insertText')) {
                document.execCommand('insertText', false, text)
            } else {
                document.execCommand('paste', false, text)
            }
        },
        placeCursor(elem: HTMLInputElement): void {
            //  Create a range
            const range = document.createRange()

            //  Create a selection
            const selection = document.getSelection()

            //  Grab the last child for our element
            const lastChild = elem.lastChild

            //  Get the node type for this
            const nodeType = lastChild ? lastChild.nodeType : null

            //  nodeType of 3 means it is just text
            if (nodeType == 3) {
                //  @ts-ignore
                range.setStart(elem.lastChild, elem.lastChild.length)
            }
            //  If it isn't text, we need to set the start to the end of the elements
            else {
                range.setStart(elem, elem.childNodes.length)
            }

            //  Remove all existing ranges
            selection.removeAllRanges()

            //  Set our new range (this autoplaces cursor at end)
            selection.addRange(range)
        },
        replaceMention(elem: HTMLInputElement): void {
            //  Grab our current mention value
            const mention = this.currentMention.value

            //  Grab the id
            const id = this.currentMention.id

            //  Replace the text with a styled version
            elem.innerHTML = elem.innerHTML.replaceAll(
                mention,
                `<strong contenteditable="false">&#xFEFF;<button class="inline-mention" style="display:inline;" data-id="${id}" onclick="goToUser(${id})">${mention}</button>&#xFEFF;</strong>&nbsp;`
            )
        },
        updateText(txt: string, autoFocus: boolean): void {
            //  Grab our node
            const node = document.getElementById('message-text-box')

            //  Update the innerText with our text (the mention)
            node.innerText = txt

            //  Tell our parent
            this.$emit('onInput', txt)

            //  Also focus our input (if autoFocus is true)
            if (autoFocus) this.placeCursor(node)
        }
    }
})
